import {
  ThemeProvider as TRThemeProvider,
  designSystem,
} from '@planningcenter/tapestry-react'
import { token } from '@planningcenter/tapestry'

import * as logos from '@planningcenter/icons/paths/logomark'
import * as churchCenter from '@planningcenter/icons/paths/church-center'
import * as general from '@planningcenter/icons/paths/general'

const { generateColorScale } = designSystem

const sharedButtonStyles = {
  fontWeight: 400,
  letterSpacing: '-0.006em',
  radius: '4px',
}

const focusVisible = {
  focusVisible: {
    outline: `2px solid ${token('--t-border-color-control-info')}`,
    outlineOffset: '2px',
  },
}

const theme = {
  id: 'api',
  button: {
    themes: {
      default: {
        fill: {
          backgroundColor: token('--t-fill-color-button-neutral-solid'),
          color: token('--t-text-color-inverted'),
          hover: {
            backgroundColor: token('--t-fill-color-button-neutral-solid-hover'),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-solid-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-solid-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        outline: {
          backgroundColor: token(
            '--t-fill-color-button-neutral-outline'
          ),
          color: token('--t-text-color-status-neutral'),
          stroke: token('--t-border-color-button-neutral'),
          hover: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-outline-hover'
            ),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-outline-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-outline-disabled'
            ),
            color: token('--t-text-color-disabled'),
            stroke: token('--t-border-color-button-neutral'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        naked: {
          backgroundColor: token('--t-fill-color-button-neutral-ghost'),
          color: token('--t-text-color-status-neutral'),
          hover: {
            backgroundColor: token('--t-fill-color-button-neutral-ghost-hover'),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-ghost-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-neutral-ghost-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
      },
      interaction: {
        fill: {
          backgroundColor: token(
            '--t-fill-color-button-interaction-solid'
          ),
          color: token('--t-text-color-inverted'),
          hover: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-solid-hover'
            ),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-solid-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-solid-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        outline: {
          backgroundColor: token(
            '--t-fill-color-button-interaction-outline'
          ),
          color: token('--t-text-color-status-info'),
          stroke: token('--t-border-color-button-info'),
          hover: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-outline-hover'
            ),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-outline-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-outline-disabled'
            ),
            color: token('--t-text-color-disabled'),
            stroke: token('--t-border-color-button-neutral'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        naked: {
          backgroundColor: token(
            '--t-fill-color-button-interaction-ghost'
          ),
          color: token('--t-text-color-status-info'),
          hover: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-ghost-hover'
            ),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-ghost-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-interaction-ghost-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
      },
      delete: {
        fill: {
          backgroundColor: token('--t-fill-color-button-delete-solid'),
          color: token('--t-text-color-inverted'),
          hover: {
            backgroundColor: token('--t-fill-color-button-delete-solid-hover'),
          },
          active: {
            backgroundColor: token('--t-fill-color-button-delete-solid-active'),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-delete-solid-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        outline: {
          backgroundColor: token(
            '--t-fill-color-button-delete-outline'
          ),
          color: token('--t-text-color-status-error'),
          stroke: token('--t-border-color-button-delete'),
          hover: {
            backgroundColor: token(
              '--t-fill-color-button-delete-outline-hover'
            ),
          },
          active: {
            backgroundColor: token(
              '--t-fill-color-button-delete-outline-active'
            ),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-delete-outline-disabled'
            ),
            color: token('--t-text-color-disabled'),
            stroke: token('--t-border-color-button-neutral'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
        naked: {
          backgroundColor: token('--t-fill-color-button-delete-ghost'),
          color: token('--t-fill-color-button-delete-solid'),
          hover: {
            backgroundColor: token('--t-fill-color-button-delete-ghost-hover'),
          },
          active: {
            backgroundColor: token('--t-fill-color-button-delete-ghost-active'),
          },
          disabled: {
            backgroundColor: token(
              '--t-fill-color-button-delete-ghost-disabled'
            ),
            color: token('--t-text-color-disabled'),
          },
          ...focusVisible,
          ...sharedButtonStyles,
        },
      },
    },
  },
  colors: {
    ...generateColorScale({
      baseColor: '#3B9CCF',
      key: 'primary',
    }),
    linkForeground: token('--t-fill-color-interaction'),
  },
  icons: {
    churchCenter,
    general,
    logos,
  },
}

export function ThemeProvider({ children }) {
  return <TRThemeProvider theme={theme}>{children}</TRThemeProvider>
}
